/*
 *   File : stepper.js
 *   Author : https://evoqins.com
 *   Description : Value with minus and plus buttons
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo } from "react";

import { Icon } from "../Icon";

const CustomStepper = (props) => {
    return (
        <div className="d-flex align-items-center gap-1 gap-sm-2 e-border-1px-white-marble e-border-radius-8 px-3 py-2">
            <button type="button"
                className={`${props.isDecreaseDisabled ? "opacity-5" : "cursor-pointer"} d-flex p-0 no-border no-outline e-bg-transparent`}
                aria-label={props.decreaseLabel}
                disabled={props.isDecreaseDisabled}
                onClick={props.onDecrease}>
                <Icon icon="minus-button" size={16} />
            </button>
            <span className="e-text-eerie-black e-primary-font-inter e-font-weight-600 e-font-12 line-height-16px text-center text-nowrap">
                {props.value}
            </span>
            <button type="button"
                className={`${props.isIncreaseDisabled ? "opacity-5" : "cursor-pointer"} d-flex p-0 no-border no-outline e-bg-transparent`}
                aria-label={props.increaseLabel}
                disabled={props.isIncreaseDisabled}
                onClick={props.onIncrease}>
                <Icon icon="add-button" size={16} />
            </button>
        </div>
    );
};

CustomStepper.defaultProps = {
    isDecreaseDisabled: false,
    isIncreaseDisabled: false,
    onDecrease: () => { },
    onIncrease: () => { },
}

export default memo(CustomStepper);
